import { getImagePath } from '../../../utils/imagePath';
import { DPR_1, DPR_2 } from '../../../utils/constants';

const componentDirectory = 'hero';

export const DesktopDarren = getImagePath({width: '496', dpr: DPR_1, componentDirectory, img: '900-darren2x.png'});
export const DesktopDarren2x = getImagePath({width: '496', dpr: DPR_2, componentDirectory, img: '900-darren2x.png'});

export const DesktopNichelle = getImagePath({width: '496', dpr: DPR_1, componentDirectory, img: '900-nichelle2x.png'});
export const DesktopNichelle2x = getImagePath({width: '496', dpr: DPR_2, componentDirectory, img: '900-nichelle2x.png'});

export const DesktopTobee = getImagePath({width: '496', dpr: DPR_1, componentDirectory, img: '900-tobee2x.png'});
export const DesktopTobee2x = getImagePath({width: '496', dpr: DPR_2, componentDirectory, img: '900-tobee2x.png'});

export const DesktopSharon = getImagePath({width: '496', dpr: DPR_1, componentDirectory, img: '900-sharon2x.png'});
export const DesktopSharon2x = getImagePath({width: '496', dpr: DPR_2, componentDirectory, img: '900-sharon2x.png'});

export const DesktopMelissa = getImagePath({width: '496', dpr: DPR_1, componentDirectory, img: '900-melissa2x.png'});
export const DesktopMelissa2x = getImagePath({width: '496', dpr: DPR_2, componentDirectory, img: '900-melissa2x.png'});

export const DesktopMatthew = getImagePath({width: '496', dpr: DPR_1, componentDirectory, img: '900-matthew2x.png'});
export const DesktopMatthew2x = getImagePath({width: '496', dpr: DPR_2, componentDirectory, img: '900-matthew2x.png'});
